import featureSupportConfig from './feature/support'

const supportConfig = {
  chatLocales: featureSupportConfig.chat.askUsAnything.locales,
  communityLinks: featureSupportConfig.help.communityUrls,
}

export default supportConfig
